/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLightningInvoice} from '../api'

 export const useQueryGetLightningInvoice = createReactQueryHook('getLightningInvoice', getLightningInvoice)
